import React, { useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import csv from '../images/csv.svg'
import edit from '../images/edit.svg'
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import homeIcon from '../images/home.svg'

const PreviousUploadedList = () => {

    const navigate = useNavigate()
    const { user } = useAuth()
    const [vendorStock, setVendorStock] = useState([])

    useEffect(() => {
        fetch(`https://vendor-managed-inventory-transparency.onrender.com/vendor-inventory-stock/code/${user.code}`)
            .then(response => response.json())
            .then(data => {
                setVendorStock(data.result)
                if(data.count === 0) {
                    document.getElementById('loading').style.display = 'none'
                    document.getElementById('result').style.display = 'block'
                }
            })
    }, [user.code])

    return (
        <div className='bg-brand'>
            <div className="container">
                <Link to='/' className='text-decoration-none'><img className='mb-2' src={homeIcon} alt="go home" /> Go Home</Link>
                <Header />

                <div className="">
                    <h2 className='text-center fs-6 fw-bold mt-2'>Previous Uploaded List</h2>
                    <p className='text-center'><i><small>last one month</small></i></p>
                    {
                        vendorStock.length > 0 ?
                            <div className="d-flex align-items-center flex-wrap">
                                {vendorStock.map(product =>
                                    <div onClick={() => navigate(`/edit-previous-uploaded-item/${product._id}`)} key={product._id} className="col-md-2 p-2">
                                        {/* d-flex align-items-center justify-content-center */}
                                        <div style={{ border: "1px solid lightgrey", borderRadius: '10px' }} className="p-2 edit-items-container">
                                            <div className="">
                                                <img className='' src={csv} alt={product.code} />
                                                <h2 style={{ fontSize: '12px' }} className='mt-3 fw-bold'>{new Date(product.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</h2>
                                            </div>

                                            <div style={{ cursor: 'pointer' }} className="d-flex align-items-center">
                                                <img width={18} src={edit} alt="edit" />
                                                <h2 style={{ fontSize: '14px' }} className='text-danger fw-bold mt-2 ps-1'>Edit</h2>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            :
                            <p id='loading'>Loading...</p>
                    }
                    <p style={{display:'none'}} id="result">No results found</p>
                </div>

            </div>
        </div>
    );
};

export default PreviousUploadedList;